import { jsx as o } from "react/jsx-runtime";
import { useMemo as l } from "react";
import p from "./styles.module.less.js";
import { MobileMenu as A } from "./mobile.js";
import { DesktopMenu as N } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as E, canLanguageUseAtticus as M } from "../../../constants.js";
import { useScreenSize as L, WidthType as _ } from "../../../utils/use-is-mobile.js";
const C = "FLOATING_CONTAINER_ID", f = "MENU_HEADER_ID", O = (d) => {
  const {
    isAuthenticated: t,
    openAuthModal: r,
    userImage: n,
    logout: i,
    hasNotifications: s,
    language: e = E,
    getTranslation: a,
    isLawyerSupported: u,
    onRequestLawyer: c
  } = d, m = l(() => M(e) ? e : void 0, [e]);
  return L() === _.Mobile ? /* @__PURE__ */ o("div", { className: p.mobileMenuWrapper, children: /* @__PURE__ */ o(
    A,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      onRequestLawyer: m ? c : void 0
    }
  ) }) : /* @__PURE__ */ o("div", { className: p.desktopMenuContainer, id: f, children: /* @__PURE__ */ o(
    N,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      onRequestLawyer: m ? c : void 0
    }
  ) });
};
export {
  C as FLOATING_CONTAINER_ID,
  f as MENU_HEADER_ID,
  O as MenuComponent
};
